export const containsProtocolDelimiter = (value: string): boolean => value.indexOf('://') > -1;

export const isValidProtocol = (protocol: string, httpsRequired = false): boolean =>
    Boolean(protocol.match(httpsRequired ? /^https:$/ : /^https?:$/));
